// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1v33q","content":"LoadingAlert_content__FCciE"};